import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="9.5" stroke={color} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4303 16.3857C10.419 16.3969 10.3721 16.4025 10.2896 16.4025H9.4009C9.3334 16.4025 9.29215 16.3969 9.27715 16.3857C9.26215 16.3744 9.24715 16.3425 9.23215 16.29L8.33215 12.285H7.00465C6.96715 12.285 6.9334 12.2719 6.9034 12.2457C6.8734 12.2194 6.8584 12.1875 6.8584 12.15V11.3738C6.8584 11.3363 6.8734 11.3044 6.9034 11.2782C6.9334 11.2519 6.96715 11.2388 7.00465 11.2388H8.10715L7.47715 8.47128C7.46215 8.41878 7.46215 8.37941 7.47715 8.35316C7.49215 8.32691 7.5484 8.31378 7.6459 8.31378H8.48965C8.54215 8.31378 8.57965 8.31941 8.60215 8.33066C8.62465 8.34191 8.6434 8.37378 8.6584 8.42628L9.27715 11.2388H10.5259L11.1671 8.42628C11.1821 8.37378 11.199 8.34191 11.2178 8.33066C11.2365 8.31941 11.2721 8.31378 11.3246 8.31378H12.2696C12.3221 8.31378 12.3578 8.31941 12.3765 8.33066C12.3953 8.34191 12.4121 8.37378 12.4271 8.42628L13.0684 11.2388H14.3171L14.9359 8.42628C14.9509 8.37378 14.9696 8.34191 14.9921 8.33066C15.0146 8.31941 15.0521 8.31378 15.1046 8.31378H15.9484C16.0459 8.31378 16.1021 8.32691 16.1171 8.35316C16.1321 8.37941 16.1321 8.41878 16.1171 8.47128L15.4871 11.2388H16.5784C16.6759 11.2388 16.7246 11.2838 16.7246 11.3738V12.15C16.7246 12.1875 16.7096 12.2194 16.6796 12.2457C16.6496 12.2719 16.6159 12.285 16.5784 12.285H15.2621L14.3621 16.29C14.3471 16.3425 14.3321 16.3744 14.3171 16.3857C14.3021 16.3969 14.2609 16.4025 14.1934 16.4025H13.3046C13.2221 16.4025 13.1753 16.3969 13.164 16.3857C13.1528 16.3744 13.1396 16.3425 13.1246 16.29L12.2134 12.285H11.3809L10.4696 16.29C10.4546 16.3425 10.4415 16.3744 10.4303 16.3857ZM11.7971 10.4738L11.6284 11.2388H11.9659L11.7971 10.4738ZM13.7096 14.0288L13.3159 12.285H14.0921L13.7096 14.0288ZM9.50215 12.285L9.88465 14.0288L10.2784 12.285H9.50215Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'coin');
export default IconComponent;
